'use client';

import { HttpLink, from } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
} from '@apollo/client-integration-nextjs';
import { ReactNode } from 'react';

export function makeClient() {
  const httpLink = new HttpLink({
    uri: process.env.NEXT_PUBLIC_API_URL,
    // TODO: Remove this once the change of the backend is deployed
    headers: {
      'service-router-backend-mercari-work-jp-dev': 'backend-pr11080.mercari-work-jp-dev',
    },
  });
  return new ApolloClient({
    defaultOptions: {
      react: {
        suspense: {
          autoDisposeTimeoutMs: 3_000,
        },
      },
    },
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            fastTimelineJobs: relayStylePagination([
              'prefCodes',
              'jobCrewCategoryIds',
              'jobBenefitIds',
            ]),
          },
        },
      },
    }),
    assumeImmutableResults: true,
    link: from([httpLink]),
    connectToDevTools: process.env.NEXT_PUBLIC_APP_ENV === 'local',
  });
}

export function ApolloClientProvider({ children, nonce }: { children: ReactNode; nonce: string }) {
  return (
    <ApolloNextAppProvider
      makeClient={makeClient}
      extraScriptProps={{
        nonce,
      }}
    >
      {children}
    </ApolloNextAppProvider>
  );
}
